import {fetchInsight} from './utils';

const CategoricalInsightMixin = {
  data() {
    return {
      categoricalValueCounts: [],
      categoricalSingleValuedData: []
    };
  },

  methods: {
    resetCategoricalData() {
      this.categoricalValueCounts = [];
      this.categoricalSingleValuedData = [];
    },

    fetchCategoricalData(filter) {
      this.categoricalColumns.forEach(col => {
        const {slug, name, type} = col;
        fetchInsight("FieldCounts", {...filter, collection: this.dataFileType}, {slug})
          .then(values => {
            if (values && Array.isArray(values)) {
              if (values.length === 1) {
                const record = values[0];
                this.categoricalSingleValuedData = [
                  ...this.categoricalSingleValuedData,
                  {
                    value: record[0],
                    count: record[1],
                    field: name
                  }
                ];
              } else {
                const isString = 'string' === type;
                const isArray = 'array' === type;
                const isObject = type === 'object';

                if (!isString) {
                  values.sort((a, b) => a[0] > b[0] ? 1 : -1);
                }

                this.categoricalValueCounts = [
                  ...this.categoricalValueCounts,
                  {values, name, slug, isString, isArray, isObject}
                ];
              }
            }
            else {
              // const isString = ['string', 'array'].includes(type);
              const isString = typeof Object.keys(values)[0] === 'string';
              const isArray = 'array' === type;
              const isObject = true;

              // if (!isString) {
              //   values.sort((a, b) => a[0] > b[0] ? 1 : -1);
              // }

              console.log('tag', name, slug, isString, isArray, isObject);
              this.categoricalValueCounts = [
                ...this.categoricalValueCounts,
                {values, name, slug, isString, isArray, isObject}
              ];
            }
          });
      });
    },

    fetchSegmentCategoricalData(filter) {
      this.categoricalColumns.forEach(col => {
        const {slug, name, type} = col;
        if (!!filter && !!filter.method && filter.method === 'segment') {
          fetchInsight("FieldCounts", {...filter, collection: this.dataFileType}, {slug})
            .then(values => {
              if (values && Array.isArray(values)) {
                if (values.length === 1) {
                  const record = values[0];
                  this.categoricalSingleValuedData = [
                    ...this.categoricalSingleValuedData,
                    {
                      value: record[0],
                      count: record[1],
                      field: name
                    }
                  ];
                } else {
                  const isString = 'string' === type;
                  const isArray = 'array' === type;
                  const isObject = type === 'object';

                  if (!isString) {
                    values.sort((a, b) => a[0] > b[0] ? 1 : -1);
                  }

                  this.categoricalValueCounts = [
                    ...this.categoricalValueCounts,
                    {values, name, slug, isString, isArray, isObject}
                  ];
                }
              }
              else {
                // const isString = ['string', 'array'].includes(type);
                const isString = typeof Object.keys(values)[0] === 'string';
                const isArray = 'array' === type;
                const isObject = true;

                // if (!isString) {
                //   values.sort((a, b) => a[0] > b[0] ? 1 : -1);
                // }

                console.log('tag', name, slug, isString, isArray, isObject);
                this.categoricalValueCounts = [
                  ...this.categoricalValueCounts,
                  {values, name, slug, isString, isArray, isObject}
                ];
              }
            });
        }
      });
    }
  },

  computed: {
    categoricalColumns() {
      const file = this.$store.getters.getFile(this.dataFileType);
      const columns = file ? file.columns : [];
      return columns.filter(col => col['is_cat']);
    },

    dataFileType() {
      throw new Error('dataFileType not Implemented');
    }
  }
};

export default CategoricalInsightMixin;
